import { CoreType } from "../../Core/Core.Interfaces";
import { GenericTableSchemaInterface } from "../../Table/Table.Interfaces";
import { VarKey } from "../../Variables/Generated/VarKey.Data";

export const FMSPlusAbandonedCarts00Table: GenericTableSchemaInterface = {
  id: "fms-plus-abandoned-carts-00",
  name: "FMS+ Abandoned Carts 00",
  description: "This table contains data regarding how many people were sent emails and texts messages via our FMS+ Abandoned Carts workflows.",
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: "Operator Name",
      variable: VarKey.OrgName
    },
    c02: {
      name: "Facility ID",
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: "Tenant ID",
      variable: VarKey.TenantId // will we have this?
    },
    c04: {
      name: "User ID",
      variable: VarKey.UserId
    },
    c05: {
      name: "1 day after lead is created SMS"
    },
    c06: {
      name: "2 days after lead is created SMS"
    },
    c07: {
      name: "3 days after lead is created SMS"
    },
    c08: {
      name: "5 days after lead is created SMS"
    },
    c09: {
      name: "7 days after lead is created SMS"
    },
    c10: {
      name: "10 days after lead is created SMS"
    },
    c11: {
      name: "14 days after lead is created SMS"
    },
    c12: {
      name: "30 days after lead is created SMS"
    },
    c13: {
      name: "1 day after lead is created Email"
    },
    c14: {
      name: "2 days after lead is created Email"
    },
    c15: {
      name: "3 days after lead is created Email"
    },
    c16: {
      name: "5 days after lead is created Email"
    },
    c17: {
      name: "7 days after lead is created Email"
    },
    c18: {
      name: "10 days after lead is created Email"
    },
    c19: {
      name: "14 days after lead is created Email"
    },
    c20: {
      name: "30 days after lead is created Email"
    },
    c21: {
      name: "SMS Link Clicked"
    },
    c22: {
      name: "Date Received"
    },
    c23: {
      name: "Sequence (A/B)"
    },
    c24: {
      name: "Email Link Clicked"
    },
    c25: {
      name: "1 day after lead is created Call"
    },
    c26: {
      name: "2 days after lead is created Call"
    },
    c27: {
      name: "3 days after lead is created Call"
    },
    c28: {
      name: "5 days after lead is created Call"
    },
    c29: {
      name: "7 days after lead is created Call"
    },
    c30: {
      name: "10 days after lead is created Call"
    },
    c31: {
      name: "14 days after lead is created Call"
    },
    c32: {
      name: "30 days after lead is created Call"
    },
    c33: {
      name: "Day that lead is created SMS"
    },
    c34: {
      name: "Day that lead is created Email"
    },
    c35: {
      name: "Day that lead is created Call"
    }
  }
};
